import React from 'react'
import { Link } from 'gatsby'
import { NavDropdown, Navbar, Nav } from 'react-bootstrap'

import HeaderLogo from './HeaderLogo'


const Navigation = () => {
    return (
        <div
            className="container-fluid"
            style={{ backgroundColor: '#001836' }}
        >
            <div>
                <Navbar expand="lg" id="site-navbar" variant="dark">
                <Navbar.Brand>
                <Link to="/">
                    <HeaderLogo />
                </Link>
                
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" >
                    <Nav className="ml-auto justify-content-end" style={{flexGrow: '1'}} >
                        <Link className="navbar-link" to="/horseshoe-yurt" activeClassName="active">
                            <span className="nav-link">Horseshoe Yurt</span>
                        </Link>
                        {/* <Link className="navbar-link" to="/events" activeClassName="active">
                            <span className="nav-link">Events</span>
                        </Link> */}
                        <Link className="navbar-link" to="/grooming" activeClassName="active">
                            <Nav.Link as="span">Grooming</Nav.Link>
                        </Link>
                        {/* <Link className="navbar-link" to="/news" activeClassName="active">
                            <span className="nav-link">News</span>
                        </Link>                         */}
                        <NavDropdown title="About Us" id="basic-nav-dropdown">
                        <Link className="navbar-link" to="/about" activeClassName="active">
                            <Nav.Link as="span">About Us</Nav.Link>
                        </Link>
                            <Link className="navbar-link" to="/events">
                                <Nav.Link as="span">Events</Nav.Link>
                            </Link>
                            <Link className="navbar-link" to="/news">
                                <Nav.Link as="span">News</Nav.Link>
                            </Link>
                            <Link className="navbar-link" to="/projects">
                                <Nav.Link as="span">Projects</Nav.Link>
                            </Link>
                            <Link className="navbar-link" to="/resources">
                                <Nav.Link as="span">Resources</Nav.Link>
                            </Link>
                        </NavDropdown>
                        <Link className="navbar-link" to="/volunteer" activeClassName="active">
                            <Nav.Link as="span">Volunteer</Nav.Link>
                        </Link>
                        <Link className="navbar-link" to="/donate" activeClassName="active">
                            <Nav.Link as="span">Donate</Nav.Link>
                        </Link>
                    </Nav>
                </Navbar.Collapse>
                </Navbar>
            </div>
        </div>
    )
}

export default Navigation